import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { withRouter } from 'react-router-dom'
import Classnames from 'classnames'
import { library } from '@fortawesome/fontawesome-svg-core'
import FactSheetDownload from './FactSheetDownload.js'
import Modal from 'react-responsive-modal'
import {
  deletePersonalStrategy,
  showPersonalStrategy,
  showAllStrategies,
  showStrategyEditor
} from '../../../actions/data'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  formatDate,
  getKeyMetrics,
  getKeyMetricsSymbols
} from '../../../common'
import './StrategyRow.css'
import StrategyAnalysis from './StrategyAnalysis.js'
import { KEY_METRICS } from './StrategyList.js'
import i18n from './../../../i18n'
import {
  faFilePdf, faFileExcel, faEyeSlash, faEye
} from '@fortawesome/free-solid-svg-icons'
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
library.add(
  faFilePdf, faFileExcel, faEyeSlash, faEye
)

class StrategyRow extends PureComponent {
  static defaultProps = {
    saveInProgress: false,
    openMenu: false,
    striped: false
  }

  constructor(props) {
    super(props)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this)
    this.handleDeleteConfirmation = this.handleDeleteConfirmation.bind(this)
    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleShowEditor = this.handleShowEditor.bind(this)
    this.handleOptimizeInDpd = this.handleOptimizeInDpd.bind(this)
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this)

    // Initialize local state
    this.state = {
      startDeletion: false,
      openMenu: this.props.openMenu
    }
  }


  //need to track openMenu for the stinkin tabs


  componentDidUpdate(prevProps) {
    // Check if openMenu prop has changed
    if (this.props.openMenu !== prevProps.openMenu) {
      // If openMenu has changed, set menuIsOpen to the same value
      this.props.setMenuIsOpen(this.props.openMenu);
    }
  }
  // Handle delete button click
  handleDeleteClick() {
    this.setState({
      startDeletion: true
    })
  }

  // Handle close of delete modal
  handleCloseDeleteModal() {
    this.setState({
      startDeletion: false
    })
  }

  // Handle delete confirmation
  handleDeleteConfirmation(idToDelete) {
    this.setState({
      startDeletion: false
    })
    this.props.deletePersonalStrategy(idToDelete)
  }

  // Handle menu button click
  handleMenuClick(idToShow) {
    // If the menu isn't open then show the given Strategy, otherwise show all
    !this.props.openMenu
      ? this.props.showPersonalStrategy(idToShow)
      : this.props.showAllStrategies()
  }

  // Handle the show editor and pass in the personalStrategy
  handleShowEditor(strategyToEdit) {
    this.props.showStrategyEditor(strategyToEdit)
  }

  // Handle the optimization with DPD
  handleOptimizeInDpd(strategyToOptimize) {
    this.props.showAllStrategies()
    window.location = '#dpd&portfolioid=' + strategyToOptimize
  }


  generateExcel = async () => {
    const { personalStrategy, allStrategies } = this.props;
    console.log('personalStrategy:', personalStrategy);
    const wb = new ExcelJS.Workbook();

    // Create the Allocations sheet
    const allocationsSheet = wb.addWorksheet('Allocations');
    allocationsSheet.addRow(['Trade Date', 'Portfolio Name', 'Asset Class', 'Ticker', 'Weight', 'Turnover', 'Name']);

    if (personalStrategy && personalStrategy.customUserModelRebalances) {
      const data = personalStrategy.customUserModelRebalances;
      const lastItem = data[data.length - 1];
      const tradeNotifications = lastItem?.tradeNotifications;
      const portfolioName = personalStrategy.name;

      tradeNotifications.forEach(notification => {
        const dateObject = notification.date ? new Date(notification.date) : new Date();
        const date = dateObject.toLocaleDateString();
        const turnover = Number(notification.turnOver.toFixed(2))
        allocationsSheet.addRow([
          date,
          portfolioName,
          notification.assetClass,
          notification.ticker,
          notification.weight,
          turnover,
          notification.name
        ]);
      });


      allocationsSheet.getColumn(1).width = 12;
      allocationsSheet.getColumn(2).width = 60;
      allocationsSheet.getColumn(3).width = 15;
      allocationsSheet.getColumn(7).width = 60;
      const allocationsHeaderRow = allocationsSheet.getRow(1);
      allocationsHeaderRow.eachCell(cell => {
        cell.font = { bold: true };
      });
    }

    // Create the Disclosures sheet
    const disclosuresSheet = wb.addWorksheet('Disclosures');
    disclosuresSheet.columns = [
      { key: 'disclosures', width: 100 }
    ];
    const data = [
      [i18n.t('excel-disclosure-text-1')],
      [i18n.t('excel-disclosure-text-2')],
      [i18n.t('excel-disclosure-text-3')],
      [i18n.t('excel-disclosure-text-4')],
      [i18n.t('excel-disclosure-text-5')],
      [i18n.t('excel-disclosure-text-6')],
      [i18n.t('excel-disclosure-text-7')]
    ];
    data.forEach((row, rowIndex) => {
      const excelRow = disclosuresSheet.addRow(row);
      if (rowIndex === 3) { // bold row 4
        excelRow.eachCell(cell => {
          cell.font = { bold: true };
        });
      }
    });
    // Set the width of column 1 to 50
    // disclosuresSheet.getColumn(1).width = 100;

    // Wrap text in the first column
    disclosuresSheet.getColumn(1).eachCell(cell => {
      cell.alignment = { wrapText: true };
    });

    const allSheet = wb.addWorksheet('All Custom Models');
    allSheet.addRow(['Trade Date', 'Portfolio Name', 'Asset Class', 'Ticker', 'Weight', 'Turnover', 'Name']);

    allStrategies.forEach(strategy => {
      if (strategy.customUserModel) {
        if (strategy && strategy.customUserModelRebalances) {
          const data = strategy.customUserModelRebalances;
          const lastItem = data[data.length - 1];
          const assetClasses = lastItem.assetClasses;
          const tickers = lastItem.tickers;
          const weights = lastItem.weights;
          const fundName = lastItem.names;
          const dateObject = new Date(lastItem.date);
          const date = dateObject.toLocaleDateString();
          const portfolioName = strategy.name;
          const turnover = 55;

          const extractedData = [];
          for (let i = 0; i < assetClasses.length; i++) {
            const row = [date, portfolioName, assetClasses[i], tickers[i], weights[i], turnover, fundName[i]];
            extractedData.push(row);
          }

          extractedData.forEach(row => {
            allSheet.addRow(row);
          });
        }
        allSheet.getColumn(1).width = 12;
        allSheet.getColumn(2).width = 60;
        allSheet.getColumn(3).width = 15;
        allSheet.getColumn(7).width = 60;

        const allHeaderRow = allSheet.getRow(1);
        allHeaderRow.eachCell(cell => {
          cell.font = { bold: true };
        });
      }
    });


    const buffer = await wb.xlsx.writeBuffer();
    const name = personalStrategy && personalStrategy.name;
    const filename = name ? `${name}.xlsx` : 'TradeNotification.xlsx';
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, filename);
  }


  // Handle the optimization with DPD
  handleRefreshData(strategyToOptimize) {
    this.props.showAllStrategies()
    window.location = '#dpd&portfolioid=' + strategyToOptimize.latestAnalysis.id
  }
  // Handle View in Fund Char
  handleViewInFundChar = (strategyToOptimize) => {
    this.props.showAllStrategies();
    window.location = '#fundchar&landingTab=3';
  }
  // Scroll to the target of the breadcrumb click
  handleBreadcrumbClick(breadcrumb) {
    let nav = document.getElementById(breadcrumb)

    if (nav) {
      nav.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
    }
  }

  renderEditAndDeleteButtons = (saveInProgress, strategyTypeIsCustom, personalStrategy, openMenu) => {
    {/* If there is a save in progress for this strategy then show the waiting icon, otherwise show buttons */ }
    return (
      <>
        {!saveInProgress ? (
          <div className='edit-delete-buttons'>

            {/* only render edit for standard strategy */}
            {!strategyTypeIsCustom ? (
              <div className='menu-button' onClick={this.handleShowEditor.bind(this, personalStrategy)}>
                <FontAwesomeIcon icon='edit' size='lg' color />
              </div>
            ) : strategyTypeIsCustom && !openMenu ? (
              <div className='menu-button' style={{ cursor: 'default' }}>
                <FontAwesomeIcon icon='edit' size='lg' color='transparent' />
              </div>
            ) : null}
            <div className='menu-button' onClick={this.handleDeleteClick}>
              <div className='cross'>
                <strong>✕</strong>
              </div>
            </div>
          </div>
        ) : (
          <div className='waiting'></div>
        )}
      </>
    )
  }

  render() {
    const { personalStrategy, saveInProgress, striped, openMenu } = this.props
    const strategyTypeIsCustom = personalStrategy.customUserModel
    const latestAnalysis = personalStrategy.latestAnalysis
    const metricsValues =
      latestAnalysis && latestAnalysis.statistics
        ? getKeyMetrics(personalStrategy.latestAnalysis.statistics)
        : null
    const metricsSymbols = latestAnalysis ? getKeyMetricsSymbols() : null

    return (
      <div>
        <div
          className={Classnames(
            'strategyrow',
            { striped: striped && !openMenu },
            { opened: openMenu }
          )}
        >
          <div
            className='menu'
            onClick={this.handleMenuClick.bind(this, personalStrategy.id)}
          >
            <FontAwesomeIcon
              icon={openMenu ? faEye : faEyeSlash}
              data-tip
              data-for={'click-to-view-details-tooltip' + personalStrategy.id}
              color={strategyTypeIsCustom ? '#0047bb' : null}
            />
          </div>
          <ReactTooltip
            key={'click-to-view-details-tooltip' + personalStrategy.id}
            id={'click-to-view-details-tooltip' + personalStrategy.id}
            type='light'
            className='tooltip'
            effect='float'
          >
            {openMenu
              ? i18n.t('click-to-go-back-to-list-tooltip')
              : i18n.t('click-to-view-details-tooltip')}
          </ReactTooltip>

          <div
            className='name'
            onClick={this.handleMenuClick.bind(this, personalStrategy.id)}
          >
            {personalStrategy.name}
          </div>

          {/* Show last updated date if the menu isnt open */}
          {!openMenu ? (
            <div className='last-updated' onClick={this.handleMenuClick.bind(this, personalStrategy.id)}>
              {formatDate(personalStrategy.updateDate)} {/*  i propose time stamp is over kill */}
            </div>
          ) : null}
          {!openMenu ? (
            <div className='inception-date' onClick={this.handleMenuClick.bind(this, personalStrategy.id)}>
              {formatDate(strategyTypeIsCustom ? personalStrategy.createDate : personalStrategy.latestAnalysis.commonPeriodStart)}
            </div>
          ) : null}

          {/* If a save is in progress then the analysis will be empty */}
          {/* {console.log('latestAnalysis?.statistics:', latestAnalysis?.statistics)}
          {console.log('openMenu:', openMenu)} */}
          {!openMenu ? (
            <div className='statistics'>
              {/* Write out the metrics */}
              {/* {console.log('KEY_METRICS:', KEY_METRICS)} */}
              {KEY_METRICS.map(metric => {
                // Get the value of the current metric
                const value = metricsValues ? metricsValues[metric] : null;
                return (
                  <div key={'stat-' + metric} className={'stat-' + metric}>
                    <span
                      className='center-dash'
                      data-tip={value ? 'This data is available after 3 months from inception of this custom model.' : ''}
                      data-for={metric + '-tooltip-' + personalStrategy.id}
                    >
                      {/* If the value exists, render it. Otherwise, render a dash */}
                      {value ? value : '-'}
                      {/* If the value for this specific metric is truthy and not a dash, render the corresponding symbol */}
                      {value && value !== '-' && <span className='symbol'>{metricsSymbols[metric]}</span>}
                    </span>
                    <ReactTooltip
                      id={metric + '-tooltip-' + personalStrategy.id}
                      className='tooltip'
                      type='light'
                      effect='float'
                    >
                      {!value ? 'This data is available after 3 months from inception of this custom model.' : ''}
                    </ReactTooltip>
                  </div>
                )
              })}
            </div>
          ) :
            latestAnalysis && openMenu ? (
              // Show buttons
              <div className='statistics open-menu'>

                <div className='select_button_action'>
                  <button onClick={this.handleViewInFundChar.bind()} data-tip data-for={'fund-compare-tooltip'}>
                    {i18n.t('fund-comparison')}
                  </button>
                  <button onClick={this.handleOptimizeInDpd.bind(this, personalStrategy.id)} data-tip data-for={'optimize-in-dpd-tooltip'}>
                    {i18n.t('optimize-in-dpd')}
                  </button>
                  <button onClick={this.handleMenuClick.bind(this, personalStrategy.id)} data-tip data-for={'back-to-list-tooltip'}>{i18n.t('back-to-list')}</button>
                  <FactSheetDownload personal_strategy_id={personalStrategy.id} openMenu={openMenu} />
                  {strategyTypeIsCustom ? (
                    <button onClick={this.generateExcel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0', outline: 'inherit' }}>
                      <FontAwesomeIcon icon={faFileExcel} />{'  '}
                      {i18n.t('trade-notification')}
                    </button>
                  ) : null}
                  <ReactTooltip key={'back-to-list-tooltip'} id={'back-to-list-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('back-to-list-tooltip')}
                  </ReactTooltip>
                  <ReactTooltip key={'optimize-in-dpd-tooltip'} id={'optimize-in-dpd-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('optimize-in-dpd-tooltip')}
                  </ReactTooltip>
                  <ReactTooltip key={'fund-compare-tooltip'} id={'fund-compare-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('fund-compare-tooltip')}
                  </ReactTooltip>
                </div>
                {this.renderEditAndDeleteButtons(saveInProgress, strategyTypeIsCustom, personalStrategy, openMenu)}
              </div>
            ) : (
              <div className='statistics' />
            )}

          {!openMenu && this.renderEditAndDeleteButtons(saveInProgress, strategyTypeIsCustom, personalStrategy, openMenu)}

          {/* If the user clicks the delete button then pop up a modal to confirm */}
          {this.state.startDeletion ? (
            <Modal
              open={this.state.startDeletion === true}
              onClose={this.handleCloseDeleteModal}
              showCloseIcon={false}
              classNames={{
                overlay: 'modal-overlay',
                modal: 'delete-modal',
                closeIcon: 'custom-closeIcon'
              }}
              center
            >
              <div>
                <br />
                {i18n.t('confirm-delete')}
                <strong>{personalStrategy.name}</strong>?<br />
                <br />
                <div className='align-right'>
                  <button
                    onClick={this.handleDeleteConfirmation.bind(
                      this,
                      personalStrategy.id
                    )}
                  >
                    {i18n.t('delete')}
                  </button>
                  <button onClick={this.handleCloseDeleteModal}>
                    {i18n.t('cancel')}
                  </button>
                </div>
              </div>
            </Modal>
          ) : null}
        </div>
        {/* Open the Analysis dropout if the user clicks the menu button */}
        {this.props.openMenu ? (
          <StrategyAnalysis
            personalStrategy={personalStrategy}
            openHoldingsEditor={this.handleShowEditor.bind(this, personalStrategy)}
          />
        ) : null}
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    allStrategies: state.data.personalStrategies,

  };
};


export default withRouter(
  connect(mapStateToProps, {
    deletePersonalStrategy,
    showPersonalStrategy,
    showAllStrategies,
    showStrategyEditor
  })(StrategyRow)
);